var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.536 4.85119C14.9327 4.38713 14.0987 4.36621 13.4729 4.79945L11.8917 5.89411L10.567 4.87512C9.93795 4.39124 9.06205 4.39124 8.43301 4.87511L2.93301 9.10588C2.50236 9.43715 2.25 9.94965 2.25 10.493V18.8006C2.25 19.3252 2.67533 19.7506 3.2 19.7506H7.3C7.82467 19.7506 8.25 19.3252 8.25 18.8006V14.2506H10.75V18.8006C10.75 19.3252 11.1753 19.7506 11.7 19.7506H15.8C16.3247 19.7506 16.75 19.3252 16.75 18.8006V10.493C16.75 9.94966 16.4976 9.43715 16.067 9.10588L13.14 6.85432L14.3267 6.03273C14.4161 5.97084 14.5352 5.97383 14.6214 6.04013L20.1525 10.2948C20.214 10.3421 20.25 10.4153 20.25 10.4929V18.2505H18V19.7505H20.8C21.3247 19.7505 21.75 19.3252 21.75 18.8005V10.4929C21.75 9.94961 21.4977 9.43711 21.067 9.10584L15.536 4.85119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/House Icon.2b683d2953f145d521ddddd6bcb8869c.svg";
export { ForwardRef as ReactComponent };